<template>
  <div class="tab-menu-container">
<!--    <el-tabs class="tab" @tab-click="tabChange" v-model="activeTab" tab-position="top">
      &lt;!&ndash;自选区   第三方&ndash;&gt;
      <el-tab-pane :label="$t('400085')" name="0"><BuyCoin /></el-tab-pane>
      <el-tab-pane :label="$t('400086')" name="0"></el-tab-pane>
    </el-tabs>
    <ul class="menu">
      <li class="menu-item">
        <i class="iconfont">&#xe7a9</i>
        &lt;!&ndash;帮助指引&ndash;&gt;
        <span>{{$t('400087')}}</span>
      </li>
      <li class="menu-item" :class="{ 'active-item': $route.path === '/myorder' }" @click="toWantUrl('/myorder')">
         <i class="iconfont">&#xe79f</i>
        &lt;!&ndash;订单&ndash;&gt;
        <span>{{$t('400088')}}</span>
      </li>
      <li :class="{ 'active-item': $route.path === '/usercenter' }" @click="toWantUrl('/usercenter')" class="menu-item">
        <i class="iconfont">&#xe7a8</i>
        <span>{{C2CUserInfo.merchantId ? $t('400089') : $t('400090') }}</span>
      </li>
      <li class="menu-item">
        <i class="iconfont">&#xe79e;</i>
        <el-popover
          placement="bottom-start"
          width="50"
          ref="pop"
          trigger="click"
          popper-class="more-popper"
          :popper-append-to-body="false"
        >
          <div class="more-popover-item" @click="toPayment">{{$t('400091')}}</div>
          <div class="more-popover-item" @click="toCreateAds">{{$t('400092')}}</div>
          <div class="more-popover-item" @click="gotToMyADs">{{$t('400093')}}</div>
          <span slot="reference" class="s-text">{{$t('400094')}}</span>
        </el-popover>
      </li>
    </ul>-->
    <div class="tab-bar-container flex-between">
      <div class="tabs">
        <span  class="inline-block pointer" @click="tabChange(0)" :class="{activeTab: $route.path == '/buy_USDT'}">P2P</span>
        <!-- {{$t('400085')}} -->
        <span class="inline-block pointer" @click="tabChange(1)" :class="{activeTab: $route.path == '/thirdParty'}">{{$t('400086')}}</span>
      </div>
      <ul class="menu" v-if="$route.path!='/thirdParty'">
        <li class="menu-item">
          <i class="iconfont">&#xe7a9</i>
          <!--帮助指引-->
          <a :href="link_22">{{$t('400087')}}</a>
        </li>
        <li class="menu-item" :class="{ 'active-item': $route.path === '/myorder' }" @click="toWantUrl('/myorder')">
          <i class="iconfont">&#xe79f</i>
          <!--订单-->
          <span>{{$t('400088')}}</span>
        </li>
        <li :class="{ 'active-item': $route.path === '/usercenter' }" @click="toWantUrl('/usercenter')" class="menu-item">
          <i class="iconfont">&#xe7a8</i>
          <span>{{C2CUserInfo.merchantId ? $t('400089') : $t('400090') }}</span>
        </li>
        <li class="menu-item">
          <i class="iconfont">&#xe79e;</i>
          <el-popover
              placement="bottom-start"
              ref="pop"
              trigger="click"
              popper-class="more-popper"
              :append-to-body="false"
          >
            <div class="more-popover-item" @click="toPayment">{{$t('400091')}}</div>
            <div class="more-popover-item" @click="toCreateAds">{{$t('400092')}}</div>
            <div class="more-popover-item" @click="gotToMyADs">{{$t('400093')}}</div>
            <div class="more-popover-item" v-if="!C2CUserInfo.merchantId" @click="applyMerchant">{{$t('300023')}}</div>
            <div class="more-popover-item" v-if="C2CUserInfo.merchantId" @click="releaseBond">{{$t('300024')}}</div>
            <span slot="reference" class="s-text">{{$t('400094')}}</span>
          </el-popover>
        </li>
      </ul>
    </div>
    <BuyCoin v-if="$route.path == '/buy_USDT'" />
    <tipModel v-if="visibleCantPublishAdDialog" :cancelButton="true" :confirmButton="true" :confirmText="$t('400095')" :cancelText="$t('400096')" @sureTip="gotoApplyPublishAd" @closeTip="visibleCantPublishAdDialog = false">
      <!--您暂时无法发布广告-->
      <h3 style="margin: 16px 0">{{$t('400097')}}</h3>
      <!--请先申请成为广告方-->
      <p style="font-size: 14px;line-height: 1.5;margin-bottom: 32px">{{$t('400098')}}</p>
    </tipModel>
    <tipModel v-if="isAuthDialog" :cancelButton="true" :confirmButton="true" :confirmText="$t('400099')" :cancelText="$t('400100')" @sureTip="Decertification" @closeTip="isAuthDialog = false">
      <!--您尚未完成身份认证-->
      <h3 style="margin: 16px 0">{{$t('400101')}}</h3>
      <!--为了您与您交易用户的账号安全,请先完成身份认证-->
      <p style="font-size: 14px;line-height: 1.5;margin-bottom: 32px">{{$t('400102')}}</p>
    </tipModel>
    <!--设置昵称弹框-->
    <div class="model" v-if="nicknameModel">
      <div class="set-nickname-model">
        <!--设置昵称-->
        <p class="title flex-between bold">{{$t('400103')}} <i class="el-icon-close pointer" @click="nicknameModel = false"></i></p>
        <div class="form">
          <!--请设置您的账号昵称,建议不要使用真实姓名.昵称长度2~10个字符.-->
          <span class="block">{{$t('400104')}}</span>
          <el-input class="nickname-input" :placeholder="$t('400103')" maxlength="10" minlength="2" v-model="nickname"></el-input>
          <!--设置昵称-->
          <el-button class="form-btn" :disabled="nickname == '' || nickname.length < 2" @click="submitNickname">{{$t('400103')}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BuyCoin from "@/views/buycoin/buycoin";
import ThirdParty from "@/views/buycoin/thirdParty";
import urls from "@/utils/baseUrl";
import { mapGetters } from "vuex";
import tipModel from "@/components/publicModel/tipModel";
import * as api from "@/views/buycoin/api";
import {c2cSystemConfig} from "@/apis/C2C";
import {getLink} from "@/apis/resource"

export default {
  data() {
    return {
      moreVisible: false,
      activeTab:
        (this.$route.name === "coin" && this.$route.params.type) || "NaN",
      linkUrl: urls.linkUrl,
      visibleCantPublishAdDialog: false,
      isAuthDialog: false,
      nicknameModel: false,
      nickname: '',
      link_22:'',
    };
  },
  components: {
    BuyCoin,
    ThirdParty,
    tipModel
  },
  computed: {
    ...mapGetters(["token", "C2CUserInfo",'language','userInfo']),
  },
  mounted() {
    this.getGetLink()
  },
  watch: {
    activeTab(v) {
      if (v === "NaN") return;
      if (this.$route.name !== "coin") {
        this.$router.push({ name: "coin", params: { type: v } });
      } else {
        // update path query type to v
        this.$router.push({ name: "coin", params: { type: v } });
      }
    },
    $route(v) {
      // if name is not coin, set activeTab to NaN
      if (v.name !== "coin") {
        this.activeTab = "NaN";
      } else {
        this.activeTab = v.params.type;
      }
    },
  },
  methods: {
    getGetLink() {
      getLink().then(res=>{
          this.link_22 = res.data.filter(item => item.type == 22)[0].link
          console.log(this.link_22,'this.link_22---this.link_22');
          
        })
    },
    gotoApplyPublishAd() {
      c2cSystemConfig().then(res => {
        if (res.data.merchantEntryway == 0) {
          this.$notify({
            message: this.$t('400105'), // 抱歉，现在暂时无法申请成为商户。
            iconClass: 'iconfont icon-cuowu1',
            customClass: 'errorIcon flex-center',
            showClose: false,
            duration: 2000,
            position: this.isDirection ? 'top-left' : 'top-right'
          })
        }else {
          this.$router.push('/becomeMember')
          this.visibleCantPublishAdDialog = false
        }
      })
    },
    Decertification() { window.location.href = `${this.linkUrl}/userCenter/identity` },
    cwTo() {
      this.token
        ? this.$router.push("/becomeMember")
        : (window.location.href = this.linkUrl + "/login");
    },
    toWantUrl(url, query) {
      if (this.$route.path == url) return;
      this.token
        ? this.$router.push(url)
        : (window.location.href = this.linkUrl + "/login");
    },
    toPayment() {
      this.token
        ? this.$router.push({ path: "/usercenter",query:{type:1} })
        : (window.location.href = this.linkUrl + "/login");
    },
    tabChange(v) {
      if (v == 1) {
        // window.location.href = this.linkUrl + "/buyCoin";
          this.$router.push('/thirdParty')
          // this.token
          //     ?
          //     : (window.location.href = this.linkUrl + "/login");

      } else {
        this.$router.push('/buy_USDT');
      }
    },
    gotToMyADs() {
      this.$refs.pop.doClose();
      if (this.$route.path !== "/myads") {
        this.token
          ? this.$router.push("/myads")
          : (window.location.href = this.linkUrl + "/login");
      }
    },
    applyMerchant() {
      if (!this.token) return (window.location.href = this.linkUrl + "/login");
      if (this.C2CUserInfo.nickname == '') return (this.nicknameModel = true)
      this.$router.push('/becomeMember')
    },
    releaseBond() {
      if (!this.token) return (window.location.href = this.linkUrl + "/login");
      this.$router.push('/becomeMember')
    },
    toCreateAds() {
      if (!this.token) return (window.location.href = this.linkUrl + "/login");
      if (this.C2CUserInfo.isAuth == 0) return (this.isAuthDialog = true);
      if (this.C2CUserInfo.nickname == '') return (this.nicknameModel = true)
      if (!this.C2CUserInfo.merchantId) return (this.visibleCantPublishAdDialog = true);
      this.$router.push("/releaseAdvertising");
    },
    submitNickname() {
      api.nicknameChange({nickname:this.nickname}).then(res => {
        this.nicknameModel = false
        this.$store.dispatch('GetC2CUserInfo')
        this.$notify({
          message: this.$t('400106'), // 设置成功
          iconClass: 'iconfont icon-wancheng-2',
          customClass: 'successIcon flex-center',
          showClose: false,
          duration: 2000,
          position:this.isDirection ? 'top-left' : 'top-right'
        })
      })
    }
  },
};
</script>
<style lang="scss">
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.more-popper {
  z-index: 1999!important;
  background: #353637;
  color: #ffffff;
  min-width: 111px;
  transform: translateX(-18px);
  cursor: pointer;
  border: none;
  padding: 12px 0;
  .more-popover-item {
    padding: 12px 16px;
    word-break: break-word;
    font-size: 14px;
    color: #fff;
    &:hover{
      background-color: #454545;
    }
  }
}

[dir = 'ltr'] .tab-menu-container {
  .tab-bar-container{
    .tabs{
      span.inline-block{
        margin-right: 32px;
      }
    }
    .menu {
      &-item {
        margin-left: 32px;
      }
      i {
        margin-right: 4px;
      }
    }
  }
}

[dir = 'rtl'] .tab-menu-container {
  .tab-bar-container{
    .tabs{
      span.inline-block{
        margin-left: 32px;
      }
    }
    .menu {
      &-item {
        margin-right: 32px;
      }
      i {
        margin-left: 4px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.set-nickname-model {
  width: 536px;
  height: 309px;
  border-radius: 4px;
  @include background_color('dialog-bg');
  padding: 48px;

  .title {
    margin-bottom: 32px;
    font-size: $font-size-normal;

    i {
      font-weight: normal;
    }
  }

  .nickname-input {
    margin: 12px 0 52px;

    ::v-deep .el-input__inner {
      background-color: transparent;
    }
  }

  ::v-deep .el-button.is-disabled.form-btn {
    @include background_color('button-bg-disabled');
    @include font_color('font-color-1')
  }
}
.active-item {
  color: #ffc72b !important;
  i {
    color: #ffc72b;
  }
}
.q-icon {
  width: 14px;
  // height: 14px;
  display: inline-block;
  vertical-align: middle;
}
.q-icon-more {
  width: 14px;
  height: 14px;
  margin-top: 4px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 32px;
}
[data-theme="moon"] .s-text {
  color: #fff;
}

// .tab-menu-container :first-child{
//   border-bottom: 1px solid;
//   @include border_color('border-color-normal');
// }

.tab-menu-container {
  .tab-bar-container{
    width: 1200px;
    margin: 0 auto 15px;
    border-bottom: 1px solid;
    @include border_color('border-color-normal');
    .tabs{
      span.inline-block{
        padding-bottom: 14px;
        // margin-right: 32px;
      }
    }
    .activeTab{
      border-bottom: 2px solid #FFC72B;
    }
    .menu {
      position: relative;
      display: flex;
      padding-bottom: 14px;
      &-item {
        list-style: none;
        width: fit-content;
        white-space: nowrap;
        // margin-left: 32px;
        cursor: pointer;
        @include font-color("font-color");
        a{
          @include font-color("font-color");
        }
      }
      i {
        // margin-right: 4px;
      }
    }
  }
}

// ::v-deep el-popover el-popper .more-popper
</style>
